import FetcherRepository from './FetcherRepository.js'

const AUTHENTICATION_TOKEN_KEY_PREFIX = 'authenticationToken'

/**
 * @class CookieFetcherRepository
 * @implements FetcherRepository
 */
export default class CookieFetcherRepository extends FetcherRepository {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.cookie
   */
  constructor({cookie, config}) {
    super()
    this._cookie = cookie
    this._config = config
    this._LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS = this._config.get('login').LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS
    this._SECURE_COOKIES = this._config.get('SECURE_COOKIES')
  }

  getAuthenticationToken({userId}) {
    return new Promise((resolve, reject) => {
      try {
        const authenticationToken = this._cookie.get(`${AUTHENTICATION_TOKEN_KEY_PREFIX}_${userId}`)
        resolve(authenticationToken)
      } catch (error) {
        reject(error)
      }
    })
  }

  setAuthenticationToken = async ({authenticationToken, userId}) => {
    this._cookie.set(`${AUTHENTICATION_TOKEN_KEY_PREFIX}_${userId}`, authenticationToken, {
      expires: this._LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS,
      secure: this._SECURE_COOKIES
    })
  }

  removeAuthenticationToken = async ({userId}) => {
    this._cookie.remove(`${AUTHENTICATION_TOKEN_KEY_PREFIX}_${userId}`)
  }
}
